import React, { useState, createRef } from "react";
import styles from "./ClientMediasTab.module.css";
import i18n from "../../Services/i18n";
import listIcon from "../../Assets/Icons/list.png";
import gridIcon from "../../Assets/Icons/grid.png";
import FileFolderPreview from "../FileFolderPreview/FileFolderPreview";
import FileUploaderModal from "../FileUploaderModal/FileUploaderModal";
import ClientService from "../../Services/clientService";
import PrivilegeValidationService from "../../Services/privilegeValidationService";
import mediaLibIcon from "../../Assets/Icons/medialib_black2.png";

import { usePrivileges } from "../../Context/PrivilegeContext";
import { useToasts } from "../../LayoutComponents/ToastContext";
import { useNavigate } from "react-router-dom";

const ClientMediasTab = ({ client, reloadDetailClient }) => {
  const [viewMode, setViewMode] = useState("grid"); // 'list' or 'grid'
  const fileUploadModal = createRef();
  const { privileges } = usePrivileges();
  const { addToast } = useToasts();

  let navigate = useNavigate();
  return (
    <>
      <FileUploaderModal
        ref={fileUploadModal}
        callback={async (thumbnail, fileId) => {
          const result = await ClientService.AddMedia(fileId, client.externalId);
          console.log(result);
          if (result) {
            reloadDetailClient(client, true);
            return true;
          } else {
            return false;
          }
        }}
        allowMultipleFiles={false}
      />
      <div className={styles.fileFolderPreview}>
        <div className={styles.sectionHeader}>
          <div className={styles.leftActions}>
            <button
              className={styles.libraryButton}
              onClick={() => {
                navigate("/mediatheque", {
                  state: {
                    paramClientId: client.externalId,
                  },
                });
              }}>
              <img src={mediaLibIcon} alt="Médiathèque" className={styles.libraryIcon} />
              {i18n.t("Generic.ViewInLibrary")}
            </button>
          </div>

          <div className={styles.toolbar}>
            <button
              className={styles.headerButton}
              onClick={async () => {
                if (
                  !PrivilegeValidationService.ClientCanAddMedia(
                    await privileges(),
                    client.medias.length,
                  )
                ) {
                  addToast(
                    i18n.t("Privilege.ValidationError.MaxMediaByClient"),
                    "PrivilegeValidationFailed",
                    "ERROR",
                    true,
                  );
                  return;
                }
                fileUploadModal.current.open();
              }}>
              {i18n.t("Generic.AddMedia")}
            </button>

            <img
              src={listIcon}
              alt="List View"
              className={`${styles.viewModeButton} ${
                viewMode === "list" ? styles.viewModeSelected : ""
              }`}
              onClick={() => setViewMode("list")}
            />
            <img
              src={gridIcon}
              alt="Grid View"
              className={`${styles.viewModeButton} ${
                viewMode === "grid" ? styles.viewModeSelected : ""
              }`}
              onClick={() => setViewMode("grid")}
            />
          </div>
        </div>

        <div className={styles.fileFolderPreviewContainer}>
          <FileFolderPreview
            refresh={() => reloadDetailClient(client, true)}
            files={client.medias}
            viewMode={viewMode}
            onFileSelected={() => {}}
            smallIcon={false}
          />
        </div>
      </div>
    </>
  );
};

export default ClientMediasTab;
